import { AccountModal } from './AccountModal';
import { useAccountModalStore } from '@/lib/stores/accountModalStore';

/**
 * Store-driven mount of the account modal. Rendered once per top-level layout
 * (RootLayout for protected routes, PublicLayout for public ones) so the modal
 * is available wherever the sidebar's UserMenu appears AND for every token-wall
 * deep-link CTA — regardless of the sidebar/sheet mount state on mobile. Only
 * one layout is active per route, so the two mounts never coexist.
 */
export function GlobalAccountModal() {
  const open = useAccountModalStore((s) => s.open);
  const section = useAccountModalStore((s) => s.section);
  const close = useAccountModalStore((s) => s.closeModal);
  return (
    <AccountModal
      open={open}
      onOpenChange={(next) => {
        if (!next) close();
      }}
      initialSection={section ?? undefined}
    />
  );
}
